import React from "react";
import { Button } from "react-bootstrap";
import star_icon from "../../../../../Assets/svg/star_icon.svg";
import parse from "html-react-parser";
import { formatString } from "helpers/common";

const SubscriptionCard = ({ plan, handleBuyNow, isCurrent, isLoading, isSubscribed }) => {
  return (
    <div className="cardCstm p-3 px-lg-4 border h-100 bg-white position-relative">
      <div className="top">
        <div className="imgWrp rounded-circle d-inline-flex align-items-center justify-content-center mb-3">
          <img src={star_icon} alt="star icon" />
        </div>
        <h4 className="m-0 fw-bold py-2">{plan.name}</h4>
        <div className="price py-2 mt-3">
          <h4 className="m-0 fw-bold themeClr text-center">
            ${plan.price}/{formatString(plan.type)}
          </h4>
        </div>
      </div>
      <div className="cardBody py-2">
        {plan.free_trial === "yes" && (
          <div
            className="label p-2 py-3 my-2 text-center"
            style={{ background: "#7da28a", borderRadius: "15px" }}
          >
            <p className="m-0 text-dark">
              Try for free {plan.free_trial_duration}-days
            </p>
          </div>
        )}
        <ul className="list-unstyled px-3 mb-0 py-2 featureList">
          {parse(plan.features)}
        </ul>
        <div className="btnWrpper mt-3">
          <Button
            onClick={() => {
              handleBuyNow(plan);
            }}
            className="d-flex align-items-center w-100 justify-content-center commonBtn"
            disabled={isCurrent || isLoading}
          >
            {isLoading ?
              "Please wait..." :
              isCurrent ?
                "Current Plan" :
                isSubscribed ?
                  "Switch Plan" :
                  "Buy Now"
            }
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionCard;
